import "./App.css";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import ErrorPage from "./pages/ErrorPage/ErrorPage";
import BasePage from "./pages/BasePage";
import AddProject from "./pages/AddProject";
import Dashboard from "./components/Dashboard/Dashboard";
import LoginPage from "./pages/LoginPage/LoginPage";
import ProtectedRoute from "./components/ProtectedRoute";

import store from "./store/store";
import { Provider } from "react-redux";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./api/queryClient";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import AppTheme from "./components/AppTheme";

const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
    errorElement: <ErrorPage />,
  },
  {
    path: "/",
    element: (
      <ProtectedRoute>
        <BasePage />
      </ProtectedRoute>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "/add-project",
    element: (
      <ProtectedRoute>
        <AddProject />
      </ProtectedRoute>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: "dashboard/*",
    element: (
      <ProtectedRoute>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
]);

function App() {
  const { i18n } = useTranslation();
  const arabic = i18n.resolvedLanguage === "ar";
  return (
    <AppTheme>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
        <ToastContainer
          // Mirrored in Arabic, like the rest of the layout.
          position={arabic ? "top-right" : "top-left"}
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={arabic}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          style={{ zIndex: 9999 }}
        />
      </Provider>
    </AppTheme>
  );
}

export default App;
